import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { currentDate_dmy, CurrentTime, date_dmy_func, loginUserDetails } from '../../../components/Common/CommonFunction';

export const PDF_ReturnReport = ({ selectedMonth, Supplier, LoginDetails, language = "mr" }) => {

    function formatYearMonth(input, lang = "en") {
        const [year, month] = input.split("-");
        const date = new Date(year, parseInt(month) - 1);
        return date.toLocaleString(lang === "mr" ? "mr-IN" : "en-US", { month: "long" }) + "-" + year;
    }

    const translations = {
        en: {
            toLine: "To",
            name: Supplier.name,
            title: "No Objection / No Due Certificate",
            bodyIntro: (month) =>
                `This is to certify that we have received and duly accounted for all credit notes related to damage, expiry, secondary schemes, and any other claims up to the month of ${month}.`,
            confirmIntro: "We confirm that:",
            points: [
                "All received credit notes have been properly entered in our books of accounts and/or reconciled with the ledger.",
                "There are no pending or outstanding credit notes for any claims pertaining to previous periods.",
                "On the basis of credit notes received from the company, we have issued corresponding credit notes to the respective distributors/retailers associated with us, strictly in line with the claims submitted by them.",
                "Accordingly, there are no pending dues/claims relating to credit notes for damage, expiry, secondary schemes, or any other category."
            ],
            signText: "Authorized Signatory\n(Seal & Stamp)",
        },
        mr: {
            toLine: "प्रति",
            name: Supplier.name,
            title: "NOC / NDC प्रमाणपत्र",
            bodyIntro: (month) =>
                `महोदय,<br/>आमच्या नोंदींनुसार, आम्हाला ${month} महिन्यापर्यंतच्या डॅमेज अँड एक्सपायरी, सेकंडरी क्लेमच्या किंवा कुठल्याही प्रकारच्या क्लेमच्या सर्व क्रेडिट नोट्स प्राप्त झाल्या आहेत. व`,
            confirmIntro: "आम्ही पुष्टी करतो की:",
            points: [
                "प्राप्त झालेल्या सर्व क्रेडिट नोट्स आमच्या लेजर बरोबर जुळत आहेत",
                "मागील कालावधीतील कोणत्याही क्लेमच्या कोणत्याही क्रेडिट नोट्स येणे बाकी नाही किंवा कुठलाही क्लेम करणे बाकी नाही.",
                "कंपनीकडून प्राप्त झालेल्या क्रेडिट नोट्सच्या आधारावर, आम्हाला संलग्न असणाऱ्या सर्व डिस्ट्रिब्युटर्स व रिटेलर्सकडून प्राप्त झालेल्या क्लेम्सच्या आधारे योग्य त्या क्रेडिट नोट आमच्याबरोबर संलग्न असलेल्या डिस्ट्रिब्युटर्स किंवा रिटेलर्सला दिल्या आहेत.",
                "त्यानुसार, मागील कालावधीतील कोणत्याही क्लेमच्या कोणत्याही क्रेडिट नोट्स येणे बाकी नाही किंवा कुठलाही क्लेम करणे बाकी नाही."
            ],
            signText: "अधिकृत स्वाक्षरीकर्ता\n(शिक्का व सही)",
        }
    };

    const t = translations[language];
    const monthText = formatYearMonth(selectedMonth, language);

    return new Promise((resolve, reject) => {
        try {
            const element = document.createElement("div");
            element.style.position = "absolute";
            element.style.top = "-9999px";
            // Use pixel value instead of mm to match canvas and PDF exactly
            element.style.width = "794px"; // A4 width at 96 DPI
            element.style.padding = "0";
            element.style.fontFamily = "'Noto Sans Devanagari', Arial, Helvetica, sans-serif";
            element.style.webkitFontSmoothing = "antialiased";
            element.style.color = "#000";
            element.style.background = "#fff"; // Optional for white BG
            element.style.overflow = "hidden"; // Prevent overflow

            element.innerHTML = `
                <div style="
                    width: 100%; 
                    max-width: 210mm;
                    margin: auto; 
                    box-sizing: border-box;
                    padding: 20px ; 
                    border: 2px solid black; 
                    padding-bottom: 400px; 
                    line-height: 1.8;
                    margin-bottom:40px;
                ">

                    <!-- Header -->
                    <div style="text-align: center; font-size: 30px; font-weight: 700; margin-bottom: 6px;">
                        ${LoginDetails.label}
                    </div>
                    <div style="text-align: center; font-size: 15px; margin-bottom: 18px;">
                        ${LoginDetails.Address ? LoginDetails.Address : loginUserDetails().PartyAddress}
                    </div>
                    <hr style="margin: 15px 0 30px 0; border: 1.5px solid black;" />

                    <!-- Date -->
                    <div style="text-align: right; font-size: 13px; font-weight: 600; margin-bottom: 40px;">
                        ${language === "mr" ? "दिनांक" : "Date"} : ${date_dmy_func()}
                    </div>

                    <!-- To -->
                    <div style="font-size: 16px; font-weight: 600; margin-bottom: 5px;">
                        ${t.toLine}
                    </div>
                    <div style="font-size: 16px; font-weight: 700; margin-bottom: 25px;">
                        ${t.name}
                    </div>

                    <!-- Title -->
                    <div style="font-size: 20px; font-weight: 700; text-align: center; margin-bottom: 30px;">
                        ${t.title}
                    </div>

                    <!-- Body -->
                    <div style="font-size: 14px; margin-bottom: 15px; ${language === "mr" ? "text-align: justify;" : ""}">
                        ${t.bodyIntro(monthText)}
                    </div>

                    <!-- Confirm -->
                    <div style="font-size: 14px; margin-bottom: 15px;">
                        ${t.confirmIntro}
                    </div>

                    <ol style="font-size: 14px; margin-left: 20px; margin-bottom: 40px;">
                        ${t.points.map(point => `<li>${point}</li>`).join("")}
                    </ol>

                    <!-- Signature -->
                    <div style="font-size: 16px; font-weight: 600; margin-bottom: 70px; white-space: pre-line;">
                        ${t.signText}
                    </div>

                    <hr style="margin: 20px 0; border: 1px solid black;" />
                </div>
            `;

            document.body.appendChild(element);

            html2canvas(element, { scale: 2, useCORS: true })
    .then((canvas) => {
        const pdf = new jsPDF("p", "pt", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        // STEP 1: Crop right side
        const cropAmount = 0; // You can adjust this value as needed
        const croppedCanvas = document.createElement("canvas");
        croppedCanvas.width = canvas.width - cropAmount;
        croppedCanvas.height = canvas.height;

        const ctx = croppedCanvas.getContext("2d");
        ctx.drawImage(
            canvas,
            0, 0, croppedCanvas.width, croppedCanvas.height, // source crop
            0, 0, croppedCanvas.width, croppedCanvas.height  // destination size
        );

        // STEP 2: Maintain proportions (no shrinking/stretching)
        const aspectRatio = croppedCanvas.width / croppedCanvas.height;
        let imgWidth = pageWidth - 36; // Give some margin
        let imgHeight = imgWidth / aspectRatio;

        if (imgHeight > pageHeight) {
            imgHeight = pageHeight;
            imgWidth = imgHeight * aspectRatio;
        }

        const xOffset = (pageWidth - imgWidth) / 2; // center align

        // STEP 3: Add cropped image to PDF
        pdf.addImage(
            croppedCanvas.toDataURL("image/jpeg"),
            "JPEG",
            xOffset, // X position
            10,      // Y position
            imgWidth,
            imgHeight
        );

        // STEP 4: Footer
        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(9);
        pdf.text(`Print Date: ${currentDate_dmy}  Time: ${CurrentTime()}`, 12, pdf.internal.pageSize.getHeight() - 6);

        pdf.setProperties({ title: `NOC Document (${currentDate_dmy})` });

        // STEP 5: Cleanup
        window.open(pdf.output("bloburl"), "_blank");
        document.body.removeChild(element);
        resolve();
    })

                .catch((error) => {
                    document.body.removeChild(element);
                    reject(error);
                });
        } catch (error) {
            reject(error);
        }
    });
};